export default __webpack_public_path__ + "static/media/account.6a01aed2.svg";